export default [{
        header: 'Panel',
    },
    {
        title: 'Management',
        route: 'management',
        icon: 'HomeIcon',
    },
    {
        title: 'Categories',
        route: 'categories',
        icon: 'ListIcon',
    },
    {
        title: 'Contents',
        route: 'contents-categories',
        icon: 'ListIcon',
    },
    {
        title: 'Educators',
        route: 'educators',
        icon: 'ListIcon',
    },
    {
        title: 'Events',
        route: 'events',
        icon: 'ListIcon',
    },
    {
        title: 'Galleries',
        route: 'galleries',
        icon: 'ListIcon',
    },
    {
        title: 'Books',
        route: 'books',
        icon: 'ListIcon',
    },
    {
        title: 'Podcasts',
        route: 'podcasts',
        icon: 'ListIcon',
    },
    {
        title: 'Forms',
        icon: 'SettingsIcon',
        children: [{
                title: 'Gsys Forms',
                icon: 'CopyIcon',
                route: 'forms-gsys',
            },
            {
                title: 'Event Forms',
                icon: 'CopyIcon',
                route: 'forms-events',
            },
            {
                title: 'Contact Forms',
                icon: 'CopyIcon',
                route: 'forms-contacts',
            },
            {
                title: 'Participants',
                route: 'forms-participants',
            },
            {
                title: 'Newsletters',
                route: 'forms-newsletter',
            },
            {
                title: 'Explicit Consent Forms',
                route: 'forms-explicit-consents',
            },
        ],
    },
    {
        title: 'Sliders',
        icon: 'MenuIcon',
        children: [{
                title: 'Home Slider',
                route: 'sliders-home',
            },
            {
                title: 'Highlights Slider',
                route: 'sliders-highlights',
            },
            {
                title: 'Programs Slider',
                route: 'sliders-programs',
            },
            {
                title: 'Interested Slider',
                route: 'sliders-interesteds',
            },
            {
                title: 'Podcast Slider',
                route: 'sliders-podcasts',
            },
        ],
    },
]